module.exports = __webpack_public_path__ + "img/bg-support-rounded.d8115353.png";